<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-keyboard-on`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 44a2 2 0 002-2V18a2 2 0 00-2-2H4a2 2 0 00-2 2v24a2 2 0 002 2h40zM30.298 10.092a.997.997 0 00.662-1.74l-6.347-5.643a.996.996 0 00-1.323 0L16.943 8.35a.996.996 0 00.662 1.741h12.693zM6 40h36V20H6v20zm25-12a1 1 0 001-1v-2a1 1 0 00-1-1H17a1 1 0 00-1 1v2a1 1 0 001 1h14zm6 7a1 1 0 01-1 1H12a1 1 0 01-1-1v-2a1 1 0 011-1h24a1 1 0 011 1v2z"/></svg>
</template>
<script>

export default {
  name: 'IconKeyboardOn',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
